<template>
    <el-header style="height: 70px;">
        <div class="header">
            <div v-if="ismobile" style="width:45px;"><van-icon size="28" name="bars" color="#666666"
                    @click="showlefttab" /></div>
            <div class="logo-box" @click="toclick('/')">
                <img src="../assets/logo.png" alt="" style="cursor: pointer">
                <h1 style="cursor: pointer">dic.cool</h1>
            </div>
            <div v-if="!ismobile" class="tab-box">
                <p class="tab-item" @click="toclick('/apk')">安装教程</p>
                <p class="tab-item" @click="toclick('/about')">使用教程</p>
                <p class="tab-item" @click="toclick('/feedback')">问题反馈</p>
                <p class="free_btn" @click="download">免费使用</p>
            </div>
        </div>
    </el-header>
</template>

<script>
export default {
    data() {
        return {
            ismobile: false,
            browserId: 1, // 浏览器id
        }
    },
    created() {
        // 通过ua判断浏览器是否是手机端
        var ua = navigator.userAgent;
        if (ua.indexOf('Mobile') != -1) {
            this.ismobile = true
        }
        if (ua.match(/Edg\/([\d.]+)/)) {
            this.browserId = 2
        } else if (ua.match(/Firefox\/([\d.]+)/)) {
            this.browserId = 3
        } else if (ua.match(/Chrome\/([\d.]+)/)) {
            this.browserId = 1
        }
    },
    methods: {
        toclick(path) {
            if (this.$route.path === path) return
            this.$router.push(path)
        },
        showlefttab() {
            this.lfettabloading = !this.lfettabloading;
        },
        download() {
            let params = {
                method: 'get',
                url: 'https://www.newacademic.online/diccool/DIC-COOL-SERVICE-V3/eventTracking/downloadlogs'
            }
            let channel = this.getChannel()
            if (channel) {
                params.params = {
                    channel
                }
            }
            this.$http(params).then(res => {
                console.log(res)
                window.open('https://addons.dic.cool/download/diccool.zip')
                this.$router.push('/apk')
            }).catch(err => {
                console.log(err)
            })
        },
        getChannel() {
            let url = window.location.href
            let urlArr = url.split('?')
            if (urlArr.length > 1) {
                let channel = urlArr[1].split('=')[0]
                let value = urlArr[1].split('=')[1]
                if (channel === 'channel' && this.channelList.includes(value)) {
                    return value
                } else {
                    return ''
                }
            } else {
                return ''
            }
        },
    }
}
</script>

<style scoped lang="scss">
.header {
    width: 1280px;
    height: 70px;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-box {
        display: flex;
        align-items: center !important;
        gap: 4px;
        cursor: pointer;

        img {
            width: 28px;
        }

        h1 {
            color: #344054 !important;
            font-size: 22px !important;
            font-weight: 700 !important;
            font-family: "Alimama ShuHeiTi" !important;
        }
    }

    .tab-box {
        display: flex;
        align-items: center;

        .tab-item {
            width: 88px;
            padding: 0 2px;
            color: #344054;
            font-size: 16px;
            font-weight: 400;
            text-align: center;
            cursor: pointer;
        }

        .free_btn {
            height: 40px;
            margin-left: 6px;
            display: flex;
            padding: 7px 16px;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            border: 1px solid rgba(0, 0, 0, 0.00);
            background: #A411D1;
            box-shadow: 0 1px 2px 0 rgba(16, 20, 40, 0.13);
            color: rgba(255, 255, 255, 0.94);
            text-align: center;
            font-family: "PingFang SC";
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
        }
    }
}
</style>

<style>
.el-header {
    padding: 0;
    height: 70px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>